export const CLUBS_MANAGE = "clubs.manage";
export const AUDIT_READ = "audit.read";
export const INSTALLATION_VIEW = "installation.view";
export const CLUBS_TEXT = "clubs.text";
